export default __webpack_public_path__ + "static/SP_bg_03-84ac3cc836eba281188a9edf0149abc6.png";